import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export default class ButtonTickets {
	constructor(element) {
		this.element = element;
		this.init();
	}

	init() {
		ScrollTrigger.create({
			trigger: this.element,
			start: 'top top',

			onEnter: () => {
				this.element.classList.add('is-sticky');
			},

			onLeaveBack: () => {
				this.element.classList.remove('is-sticky');
			},
		});
	}
}
